export const scorePay = {
    active: "airRecharge",
    type: "logo",
    tabs: {
        airRecharge: "机场高铁",
        transportation: "交通出行",
        localLife: "本地生活",
        entertainment: "休闲娱乐",
        travel: "游玩·旅游",
        foods: "美食·饮品",
        plus: "会员权益"
    },
    data: {
        airRecharge: [
            {
                name: "海南航空",
                jingle: "金鹏积分",
                link: "https://platform.jifen360.com/qjf_store/?type=coupon&couponId=284&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hna.png",
                isNew: true
            },
            {
                name: "四川航空",
                jingle: "金熊猫里程",
                link: "https://platform.jifen360.com/qjf_store/?type=unline&business=scal&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/sichuan_air.png"
            },
            {
                name: "中国国际航空",
                jingle: "凤凰知音里程",
                link: "https://platform.jifen360.com/qjf_store/?type=coupon&couponId=21&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/china_air.png"
            },
            {
                name: "厦门航空",
                jingle: "白鹭积分",
                link: "https://platform.jifen360.com/qjf_store/?type=unline&business=xm_air&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/xiamen_air.png"
            },
            {
                name: "工商银行",
                jingle: "信用卡积分",
                link: "https://platform.jifen360.com/qjf_store/?type=unline&business=icbc&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/icbc.png"
            },
            {
                name: "明宇商旅",
                jingle: "明宇会积分",
                link: "https://platform.jifen360.com/qjf_store/?type=unline&business=myh&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/myh.png"
            }
        ],
        transportation: [
            {
                name: "天府通地铁卡",
                jingle: "川航里程全额抵",
                link: "https://pay.jifen360.com/third/tianfuTong/index.html?$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/tft.png"
            },
            {
                name: "厦门地铁/BRT",
                jingle: "白鹭积分兑换",
                link: "https://payment.jifen360.com/xiamenair_metro/?$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/xiamen_metro.png"
            },
            {
                name: "石家庄地铁",
                jingle: "白鹭积分兑换",
                link: "https://payment.jifen360.com/metro/?metro=shx&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/shx.png"
            },
            {
                name: "航旅纵横",
                jingle: "航旅纵横",
                link: "https://payment.jifen360.com/third_coupon/into?template=hanglv&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hanglv.png"
            },
            {
                name: "哈啰单车",
                jingle: "川航里程兑换",
                link: "https://app.e-pointchina.com.cn/gateway/entry/scair_master/app/saschk0100010002?utm_source=CHAPP",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hello.png"
            },
            {
                name: "南昌地铁",
                jingle: "白鹭积分兑换",
                link: "https://payment.jifen360.com/metro/?metro=llx",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/llx.png"
            },
            {
                name: "飞常准",
                jingle: "川航里程兑换",
                link: "https://static.variflight.com/assets/activity/airline-mileage-sichuan/index.html?feeyo_nav_right_style=&feeyo_nav_background=0x00ffffff&feeyo_nav_foreground=0xff000000#/",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/fcz.png",
                // isNew: true
            },
            {
                name: "精典养车",
                jingle: "川航里程兑换",
                link: "https://coupon.jifen360.com/category/?type=jdxc",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/jdyc.png",
                // isNew: true
            },
            {
                name: "一嗨租车",
                jingle: "航空积分兑换",
                link: "https://platform.jifen360.com/?type=hiCar",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/yihi.png",
                isNew: false
            },
            {
                name: "特来电",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=tld&recharge=scal&from=f",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/telaidian.png",
                isNew: true
            },
            {
                name: "星星充电",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=xxcd&from=def",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/xingxingchongdian.png",
                isNew: true
            },
        ],
        localLife: [
            {
                name: "红旗连锁",
                jingle: "5000+门店",
                link: "https://pay.jifen360.com/scan/login.html?mark=fa4a650f0bdfd569a4a6fb20bd6d2ad5&$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hongqi.png"
            },
            {
                name: "罗森便利店",
                jingle: "1000+门店",
                link: "https://shopping-mall.jifen360.com/pages/lawson/index?$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/lawson.png"
            },
            {
                name: "山姆会员卡",
                jingle: "线上线下都适用",
                link: "https://payment.jifen360.com/third_coupon/third_page/PdiWKaNOZCfX?$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/sams.png"
            },
            // {
            //     name: "云闪付礼包",
            //     jingle: "线上线下都适用",
            //     link: "https://pay.jifen360.com/third/union_pay/?$_=" + Math.random(),
            //     // notNet: true,
            //     logo: require("@/assets/images/logo/union_pay.png")
            // },
            // {
            //     name: "美团零花",
            //     jingle: "川航里程兑换",
            //     link: "https://m.sichuanair.com/zschresource/admanage/ad/3782/ad/index.html?time=1673242458958&utm_content=%E7%BE%8E%E5%9B%A20627&$_=" + Math.random(),
            //     // notNet: true,
            //     logo: require("@/assets/images/logo/meituan.png")
            // },
            {
                name: "生活缴费",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/life_pay/?$_=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/live_pay.png"
            },
            {
                name: "菜鸟裹裹",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=cngg&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/cngg.png",
            },
            {
                name: "乐摩吧",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=lmb&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/lmb.png"
            },
            {
                name: "见福便利店",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/jf_mark/?mark=908D0E4DFD588E10CA40B68662C4565D&randome=20240312&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/jf.png",
            },
            {
                name: "良品铺子",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=lppz&recharge=scal&rand=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/lppz.png"
            },
            // {
            //     name: "抖音",
            //     jingle: "川航里程兑换",
            //     link: "https://sichuan-airlines.jifen360.com/coupon_life/?coupon=douyin&rand=" + Math.random(),
            //     // isNew: true,
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/douyin.png"
            // },
            {
                name: "壳牌",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/coupon_life/?coupon=qiaopai&rand=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/qiaopai.png"
            },
            {
                name: "爽客",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/third_page/AQOZtXhBCbFp?$_=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/sk.png"
            },
            {
                name: "轻喜到家",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/life_ser/?type=qxdj&rand=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/qxdj.png"
            },
            {
                name: "天猫超市",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=tianmao&recharge=scal&from=def&$_=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/tmcs.png"
            },
            // {
            //     name: "蓉城阳光",
            //     jingle: "川航里程兑换",
            //     link: "https://vip.jifen360.com?tpl=rc&$_=" + Math.random(),
            //     // isNew: true,
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/rcyg.png"
            // },
            {
                name: "盒马鲜生",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=jstk-hm&$_=" + Math.random(),
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hema.png"
            },
            // {
            //     name: "宜家家居",
            //     jingle: "川航里程兑换",
            //     link: "https://platform.jifen360.com/?type=jstk-yj&$_=" + Math.random(),
            //     isNew: false,
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/yijia.png"
            // },
            {
                name: "奥特乐",
                jingle: "川航里程兑换",
                link: "https://coupon.jifen360.com/category/?type=atl-scal&$_=" + Math.random(),
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/atl.png"
            },
            {
                name: "外交官",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/third_page/zYxlYaJUYCYJ?$_=" + Math.random(),
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/wjg.png"
            },
            {
                name: "便宜坊生鲜超市",
                jingle: "白鹭积分兑换",
                link: "https://coupon.jifen360.com/category/?type=pyf-xmair&$_=" + Math.random(),
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/pyf.png"
            },
            {
                name: "洛杉奇|金凤扒鸡",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/third_page/RIeneIADLMuy",
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/lsq.png"
            },
            {
                name: "北国超市",
                jingle: "白鹭积分兑换",
                link: "https://coupon.jifen360.com/category/?type=beiguo-xmair",
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/beiguo.png"
            },
            {
                name: "滔博运动",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=taobo&recharge=scal&from=def",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/taobo.png"
            },
            {
                name: "畹町",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=wanding&recharge=scal&from=def",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/wanding.png"
            },
            {
                name: "朴朴超市",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=jstk-pupu&from=def",
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/pupu.png"
            },
            {
                name: "大润发",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=darunfa&recharge=scal&from=scal",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/darunfa.png"
            },
            {
                name: "永辉超市",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=yonghui&recharge=scal&from=scal",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/yonghui.png"
            },
        ],
        entertainment: [
            {
                name: "爱奇艺",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=iqiyi&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/iqiyi.png"
            },
            {
                name: "优酷",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=youku&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/youku.png"
            },
            {
                name: "喜马拉雅",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=xim&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/xim.png"
            },
            {
                name: "电影票",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=movie&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/movie.png"
            },
            {
                name: "小米影视",
                jingle: "航空积分兑换",
                link: "https://chqjf.91bak.com/p/xmys?rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/xiaom.png"
            },
            // {
            //     name: "蛋仔派对",
            //     jingle: "川航里程兑换",
            //     isNew: true,
            //     link: "https://game.jifen360.com/?type=dzpd&rand=" + Math.random(),
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/dzpd-logo.png"
            // },
            // {
            //     name: "奇游加速器",
            //     jingle: "川航里程兑换",
            //     // isNew: true,
            //     link: "https://game.jifen360.com/?type=qyjsq&rand=" + Math.random(),
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/qyjsq-logo.png"
            // },
            {
                name: "樊登读书",
                jingle: "川航里程兑换",
                // isNew: true,
                link: "https://sichuan-airlines.jifen360.com/coupon_life/?coupon=fandeng&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/fdRead.png"
            },
            {
                name: "哔哩哔哩",
                jingle: "航空积分兑换",
                isNew: true,
                link: "https://platform.jifen360.com/?type=bilibili",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/bilibili.png"
            },
        ],
        travel: [
            {
                name: "欢乐谷",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/into?template=oct&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/oct.png"
            },
            {
                name: "成渝文旅一卡通",
                jingle: "航空积分兑换",
                link: "https://coupon.jifen360.com/category/?type=sqwl&rand=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/sqwl.png"
            },
            {
                name: "meland",
                jingle: "航空积分兑换",
                link: "https://payment.jifen360.com/third_coupon/third_page/RbpMMsnekTno?rand=" + Math.random(),
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/meland.png"
            },
            {
                name: "河北文旅一卡通",
                jingle: "航空积分兑换",
                link: "https://coupon.jifen360.com/category/?type=hbwl-xmair&rand=" + Math.random(),
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hbwl.png"
            },
        ],
        foods: [
            {
                name: "书亦烧仙草",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/coupon_life/?coupon=shuyi&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/shuyi.png",
            },
            {
                name: "瑞幸咖啡",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/coupon_life/?coupon=luckin&rand=" + Math.random(),
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/luckin.png"
            },
            {
                name: "全家|德克士",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/coupon_life/?coupon=nakebao&rand=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/nakebao.png"
            },
            {
                name: "烤匠烤鱼",
                jingle: "川航里程兑换",
                link: "https://sichuan-airlines.jifen360.com/life_ser/?type=kaojiang&rand=" + Math.random(),
                // isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/kaojiang.png"
            },
            // {
            //     name: "兵立王",
            //     jingle: "川航里程兑换",
            //     link: "https://payment.jifen360.com/third_coupon/?recharge=scal&template=blw&rand=" + Math.random(),
            //     // isNew: true,
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/blw.png"
            // },
            // {
            //     name: "豪客来",
            //     jingle: "航空积分兑换",
            //     link: "https://payment.jifen360.com/third_coupon/third_page/MCUeqbusvjVz?rand=" + Math.random(),
            //     isNew: false,
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hkl.png"
            // },
            // {
            //     name: "Hibake",
            //     jingle: "川航里程兑换",
            //     link: "https://coupon.jifen360.com/category/?type=hibake-scal&rand=" + Math.random(),
            //     isNew: true,
            //     logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hibake.png"
            // },
            {
                name: "何师烧烤",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=hssk&recharge=scal&rand=" + Math.random(),
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hssk.png"
            },
            {
                name: "廖记棒棒鸡",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=liaoji",
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/bbj.png"
            },
            {
                name: "星巴克",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=starBucks",
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/star.png"
            },
            {
                name: "好利来",
                jingle: "川航里程兑换",
                link: "https://coupon.jifen360.com/category/?type=hll-scal&from=def",
                isNew: false,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/hll.png"
            },
            {
                name: "紫燕百味鸡",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=ziyan&from=def",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/ziyan.png"
            },
            {
                name: "奈雪的茶",
                jingle: "川航里程兑换",
                link: "https://payment.jifen360.com/third_coupon/?template=naixue&recharge=scal&from=def",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/naixue.png"
            },
            {
                name: "元祖",
                jingle: "川航里程兑换",
                link: "https://coupon.jifen360.com/category/?type=yuanzu&from=def",
                isNew: true,
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/yuanzu.png"
            },
        ],
        plus: [
            {
                name: "京东plus会员",
                jingle: "川航里程兑换",
                link: "https://platform.jifen360.com/?type=jd",
                logo: "https://quanjifen-oss.oss-cn-shenzhen.aliyuncs.com/jfhg/logo/jd-plus.png",
            },
        ]
    }
}

export const mallLst = {
    active: "shopping",
    type: "banner",
    tabs: {
        shopping: "全积分商城",
        supplier: "送川航里程",
        xmAir: "送厦航积分",
    },
    data: {
        supplier: {
            image: require("@/assets/images/supplier.png"),
            link: "https://mall.jifen360.com/pages/small_page/index?id=25&show=scal&$_=" + Math.random(),
            name: "送川航里程",
            jingle: ""
        },
        shopping: {
            image: require("@/assets/images/shopping.png"),
            link: "https://mall.jifen360.com/pages/index/index?$_=" + Math.random(),
            name: "全积分商城",
            jingle: ""
        },
        xmAir: {
            image: require("@/assets/images/xm_air.png"),
            link: "https://mall.jifen360.com/pages/small_page/index?id=26&show=xm_air&$_=" + Math.random(),
            name: "送厦航积分",
            jingle: ""
        }
    }
}

export const adv = [
    {
        name: "国航双礼券｜里程消费免费领",
        background: "#DBE7FD",
        image: "https://images.jifen360.com/sys/china-air.jpg",
        url: "https://m.airchina.com.cn/ac/c/invoke/activity/xnhzlyh5@pg",
        title: "国航双礼券｜里程消费免费领"
    },
    {
        name: "里程当钱花",
        background: "#DBE7FD",
        image: "https://images.jifen360.com/sys/scal.png",
        url: "https://wx.17u.cn/bus/?refid=2000262199",
        title: "里程当钱花"
    },
    {
        name: "白鹭会员积分兑换",
        background: "#DDF3FE",
        image: "https://images.jifen360.com/sys/xm_air.png",
        url: "https://payment.jifen360.com/third_coupon/third_page/BnEsVtZFfTGC",
        title: "白鹭会员积分兑换"
    },
    {
        name: "花/赚航空积分",
        background: "#FFF1E3",
        image: "https://images.jifen360.com/sys/qjf.png",
        url: "https://mall.jifen360.com",
        title: "全积分商城"
    },

]
